import React from "react";
import { useNavigate } from "react-router-dom";

const ContentManagement = ({ data = "#N/A" }) => {
  const navigate = useNavigate();
  return (
    <>
      <section className="ct_py_80">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div class="policy-wrapper">
                <div className="mb-4">
                  <h1 className="d-flex align-items-center">
                    {" "}
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(-1);
                      }}
                      class="ct_back_icon ct_fs_18"
                    >
                      <i class="fa-solid fa-angle-left"></i>
                    </a>
                    {data}
                  </h1>
                  <p class="updated-date">Last Updated: February 2026</p>
                </div>

                <p>
                  Welcome to our Privacy Policy page. Your privacy is important
                  to us. This Privacy Policy explains how we collect, use, and
                  protect your personal information.
                </p>

                <h2>1. Information We Collect</h2>
                <p>We may collect the following types of information:</p>
                <ul>
                  <li>
                    Personal details such as name, email address, and phone
                    number.
                  </li>
                  <li>
                    Account information when you register on our platform.
                  </li>
                  <li>
                    Usage data such as pages visited and interactions with our
                    services.
                  </li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <p>We use the collected information to:</p>
                <ul>
                  <li>Provide and improve our services.</li>
                  <li>Respond to customer support requests.</li>
                  <li>Send important updates and notifications.</li>
                  <li>Enhance security and prevent fraud.</li>
                </ul>

                <h2>3. Cookies Policy</h2>
                <p>
                  Our website may use cookies to improve user experience.
                  Cookies help us understand how visitors interact with our
                  platform.
                </p>

                <h2>4. Data Protection</h2>
                <p>
                  We implement strong security measures to protect your personal
                  data. However, no online platform can guarantee 100% security.
                </p>

                <h2>5. Sharing of Information</h2>
                <p>
                  We do not sell or rent your personal information. We may share
                  information only when required by law or for service
                  improvement.
                </p>

                <h2>6. Your Rights</h2>
                <p>You have the right to:</p>
                <ul>
                  <li>Access, update, or delete your personal information.</li>
                  <li>Opt-out of marketing communications.</li>
                  <li>Request a copy of the data we store.</li>
                </ul>

                <h2>7. Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please
                  contact us at:
                  <strong>support@example.com</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContentManagement;
